<template>

  <el-card class="infinite-list-wrapper">
    <el-table ref="multipleTable" v-loading="loading" element-loading-text="拼命加载中" element-loading-background="rgba(255, 255, 255, 0.8)" :data="page.rows" tooltip-effect="dark" style="margin-top: 0px; width: 100%;">

      <el-table-column prop="mobile" label="标题">
        <template slot-scope="scope">

          <router-link :to="{path:'/noticeDetail',query:{id:scope.row.id}}">
            <span class="dot" v-if="scope.row.flag == 0"></span>

            <span class="mainColor">{{scope.row.title}}</span>
          </router-link>
        </template>
      </el-table-column>
      <el-table-column prop="operator" label="创建人"></el-table-column>
      <el-table-column prop="createTime" label="发布时间"></el-table-column>
    </el-table>

    <el-pagination background layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 30, 40]" style="margin-top: 20px;text-align: right;" :total="page.total" :page-size="page.pageSize" :current-page="page.pageNumber" @size-change="sizeChange" @current-change="currentChange"></el-pagination>
  </el-card>

</template>

<script>
export default {
  name: "notice-list",

  data () {
    return {
      loading: false,

      page: {
        rows: [],
        pageSize: 10,
        pageNumber: 1,
        pages: 1,
      },
    }
  },

  methods: {
    sizeChange (pageSize) {
      this.page.pageSize = pageSize;
      this.getNoticeList();
    },
    currentChange (pageNumber) {
      this.page.pageNumber = pageNumber;
      this.getNoticeList();
    },

    getNoticeList () {
      this.api.user
        .pageList({
          pageSize: this.page.pageSize,
          pageNumber: this.page.pageNumber
        }).then(res => {
          if (res.success) {
            this.page.rows = res.data.records;
            this.page.total = res.data.total;

          } else {
            this.$message.error(res.message);
          }
        });
    }
  },
  created () {
    this.getNoticeList();
  },
}
</script>
<style lang="less">
.infinite-list-wrapper {
  .mb15 {
    margin-bottom: 15px;
  }
  .el-badge__content.is-fixed.is-dot {
    right: 47px !important;
    top: 15px !important;
  }
  .dot {
    display: inline-block;
    height: 10px;
    width: 10px;
    border-radius: 50%;
    background: #409eff;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/notice/noticeList.vue